/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S7_HeadingInputs */

const tr_iletisim_s7_heading = /** @type {(inputs: Iletisim_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şikayet ve Tüketici Hakkı Kanalları`)
};

const en_iletisim_s7_heading = /** @type {(inputs: Iletisim_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complaints and consumer rights channels`)
};

const de_iletisim_s7_heading = /** @type {(inputs: Iletisim_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschwerden und Kanäle für Verbraucherrechte`)
};

const ru_iletisim_s7_heading = /** @type {(inputs: Iletisim_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жалобы и каналы защиты прав потребителей`)
};

/**
* | output |
* | --- |
* | "Complaints and consumer rights channels" |
*
* @param {Iletisim_S7_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s7_heading = /** @type {((inputs?: Iletisim_S7_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S7_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s7_heading(inputs)
	if (locale === "de") return de_iletisim_s7_heading(inputs)
	if (locale === "ru") return ru_iletisim_s7_heading(inputs)
	return tr_iletisim_s7_heading(inputs)
});